<div id="content">
  <div class="page-title">
    <h1>{{ page_title }}</h1>
    <div class="page-title-actions">
      <button
        mat-stroked-button
        class="edit-bisual-company-button"
        type="button"
        (click)="editBisualCompany()"
        [disabled]="!permissions.validateDepartment(['direction', 'finance']) || is_opening_bisual_company"
      >
        <mat-icon>business</mat-icon>
        Editar Consultoria Bisual SL
      </button>
      <button mat-flat-button color="accent" (click)="addCompany()" [disabled]="!permissions.validateDepartment(['direction', 'finance'])">
        <mat-icon style="margin-right: 10px">person_add</mat-icon>
        Añadir empresa
      </button>
    </div>
  </div>

  <div class="bisual-table">
    <form class="card paginator" [formGroup]="filterForm">
      <mat-paginator
        [length]="length"
        [pageSize]="pageSize"
        [pageSizeOptions]="pageSizeOptions"
        [pageIndex]="pageIndex"
        (page)="changePage($event)"
        style="margin-right: auto"
      ></mat-paginator>

      <mat-form-field appearance="outline" class="bisual-paginator-select">
        <mat-label>Estado</mat-label>
        <mat-select formControlName="scopes">
          <mat-option value="withActiveCompanyProducts">Activos</mat-option>
          <mat-option value="withoutActiveCompanyProducts">Inactivos</mat-option>
          <mat-option value="">Todos</mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field>
        <input matInput type="text" formControlName="search" />
        <button matSuffix mat-icon-button aria-label="Clear">
          <mat-icon>search</mat-icon>
        </button>
      </mat-form-field>
    </form>

    <div class="bisual-table-container">
      <table mat-table [dataSource]="dataSource">
        <ng-container matColumnDef="name">
          <th mat-header-cell *matHeaderCellDef>Nombre de empresa</th>
          <td mat-cell *matCellDef="let company; dataSource: dataSource">
            <a [routerLink]="['/employees', 'direction', 'companies', company.id]">{{ company.fact_name }}</a>
          </td>
        </ng-container>

        <ng-container matColumnDef="active_products">
          <th mat-header-cell *matHeaderCellDef>Productos activos</th>
          <td mat-cell *matCellDef="let company; dataSource: dataSource">{{ company.active_company_products_count }}</td>
        </ng-container>

        <ng-container matColumnDef="account_manager">
          <th mat-header-cell *matHeaderCellDef>Account manager</th>
          <td mat-cell *matCellDef="let company; dataSource: dataSource">
            @if (company.account_managers.length === 0) {
              <span class="account-manager-empty">—</span>
            } @else {
              <div class="account-managers">
                @for (account_manager of company.account_managers; track account_manager.full_name) {
                  <div class="account-manager">
                    @if (account_manager.profile_picture_url) {
                      <img [ngSrc]="account_manager.profile_picture_url" [alt]="account_manager.full_name" width="25" height="25" />
                    }
                    <span>{{ account_manager.full_name }}</span>
                  </div>
                }
              </div>
            }
          </td>
        </ng-container>

        <ng-container matColumnDef="status">
          <th mat-header-cell *matHeaderCellDef>Estado</th>
          <td mat-cell *matCellDef="let company; dataSource: dataSource">
            <span class="status-badge" [class.status-active]="company.is_active" [class.status-inactive]="!company.is_active">
              {{ company.status_label }}
            </span>
          </td>
        </ng-container>

        <ng-container matColumnDef="actions">
          <th mat-header-cell *matHeaderCellDef></th>
          <td mat-cell *matCellDef="let company; let i = index; dataSource: dataSource">
            <button mat-icon-button [matMenuTriggerFor]="menu">
              <mat-icon>more_vert</mat-icon>
            </button>
            <mat-menu #menu="matMenu">
              <button
                mat-menu-item
                [routerLink]="['/employees', 'direction', 'companies', company.id]"
                [disabled]="!permissions.validateDepartment(['direction', 'finance'])"
              >
                <mat-icon matPrefix>edit</mat-icon>
                Editar empresa
              </button>
              <button mat-menu-item (click)="deleteCompany(i)" [disabled]="!permissions.validateDepartment(['direction', 'finance'])">
                <mat-icon matPrefix>delete</mat-icon>
                Borrar empresa
              </button>
            </mat-menu>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
      </table>
    </div>
  </div>
</div>
